<template>
  <div class="table-column">
    <div
      v-for="title in titles"
      :key="title.dataIndex"
      class="table-column__cell"
    >
      <div
        v-if="$nuxt.$breakpoints.sMd && (title.name || title.titleSlot)"
        class="table-column__cell-title"
      >
        <slot
          v-if="title.titleSlot"
          :name="`#${title.dataIndex}`"
          :title="title"
        ></slot>

        <span
          v-else
          v-html="title.name"
        ></span>
      </div>

      <template v-if="title.columnSlot">
        <div class="table-column__cell-content">
          <slot
            :name="title.dataIndex"
            :column="column"
          ></slot>
        </div>
      </template>

      <div
        v-else
        class="table-column__cell-content"
        v-html="column[title.dataIndex]"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableColumn',
  props: {
    titles: {
      type: Array,
      required: true
    },
    column: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style lang="scss">
.table-column {
  display: contents;

  &:nth-child(2) .table-column__cell {
    border-left: 1px solid rgba(0, 0, 0, 0.1);
  }

  &:nth-child(2) .table-column__cell:first-child {
    border-top-left-radius: 12px;
  }

  &:nth-child(2) .table-column__cell:last-child {
    border-bottom-left-radius: 12px;
  }

  &:last-child .table-column__cell {
    border-right: 1px solid rgba(0, 0, 0, 0.1);
  }

  &:last-child .table-column__cell:first-child {
    border-top-right-radius: 12px;
  }

  &:last-child .table-column__cell:last-child {
    border-bottom-right-radius: 12px;
  }

  &:nth-child(n) .table-column__cell:nth-child(n) {
    @media (max-width: $breakpoint-lg) {
      border: none;
    }
  }

  &:nth-child(n) .table-column__cell:nth-child(n):not(:last-child) {
    @media (max-width: $breakpoint-lg) {
      border-bottom: 1px solid $grayBorder;
    }
  }

  @media (max-width: $breakpoint-lg) {
    display: flex;
    flex-direction: column;
    border: 1px solid $grayBorder;
    border-radius: 12px;
    padding: 8px 16px;
  }
}

.table-column__cell {
  border-bottom: 1px solid transparentize($primary, 0.9);
  padding: 16px;

  @media (max-width: $breakpoint-lg) {
    padding: 16px 0;
  }

  &:first-child {
    border-top: 1px solid rgba(0, 0, 0, 0.1);
  }
}

.table-column__cell-title {
  display: none;
  margin-bottom: 16px;
  color: transparentize($primary, 0.4);

  @media (max-width: $breakpoint-lg) {
    display: block;
  }
}

.table-column .btn {
  width: auto;
  margin-top: auto;

  @media (max-width: $breakpoint-md) {
    width: 100%;
  }
}

.table-column__cell-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 100%;

  *:last-child {
    margin-bottom: 0;
  }
}
</style>